module.exports = __webpack_public_path__ + "img/9.48a36f56.png";